import '../../stylesheets/components/collapsible_sidebar.scss'

export class CollapsibleSidebar {
  constructor(element) {
    this.element = element;
    this.collapsed = element.classList.contains('d-none');
    if(this.collapsed)
      this.element.style.width = "0"

    this.timeoutId = null;
    //this.toggleCollapse(this.collapsed)

    document.querySelectorAll(`[data-toggle="collapse-horizontal"][data-target="${element.id}"]`).forEach(toggleButton => {
      toggleButton.onclick = event => this.toggleHandler(event)
    })
  }

  toggleCollapse(force=null){
    this.collapsed = force !== null ? force : !this.collapsed
    if(this.collapsed) {
      this.element.style.width = "0"
      if(this.timeoutId) clearTimeout(this.timeoutId)
      this.timeoutId = setTimeout(() => {
        this.element.classList.toggle('d-none', true)
      }, 350) // delay setting display = none, as it cannot be transitioned
    } else {
      this.element.classList.toggle('d-none', false)
      setTimeout(() => {
        this.element.style.width = "300px"
      }, 33) // if width is changed at the same time as display was none, the transition is skipped
    }
  }

  toggleHandler(event) {
    this.toggleCollapse()
    event.currentTarget.classList.toggle('toggled', !this.collapsed)
    event.currentTarget.setAttribute('aria-expanded', !this.collapsed)
    event.preventDefault()
  }
}